module.exports = __webpack_public_path__ + "img/capslock.8192644d.svg";